import * as Yup from 'yup';

const phoneRegExp = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const createPatientInformationSchema = (t) => Yup.object().shape({
  firstName: Yup.string()
    .required(t('booking.form.validation.firstNameRequired')),
  middleName: Yup.string(),
  preferredFirstName: Yup.string(),
  lastName: Yup.string()
    .required(t('booking.form.validation.lastNameRequired')),
  platformPreference: Yup.string()
    .required(t('booking.form.validation.platformRequired')),
  email: Yup.string()
    .when("platformPreference", {
      is: "email",
      then: () => Yup.string()
        .matches(emailRegExp, t('booking.form.validation.emailInvalid'))
        .required(t('booking.form.validation.emailRequired')),
      otherwise: () => Yup.string().notRequired(),
    }),
  phone: Yup.string()
    .matches(phoneRegExp, t('booking.form.validation.phoneInvalid'))
    .required(t('booking.form.validation.phoneRequired')),
  smsOptIn: Yup.bool()
    .when("platformPreference", {
      is: "sms",
      then: () => Yup.bool().required().oneOf([true], t('booking.form.validation.smsOptInRequired')),
      otherwise: () => Yup.bool().notRequired(),
    }),
});
